import { Injectable } from '@angular/core';
import { BaseConfig } from 'shared';
import packageInfo from '../../package.json';

@Injectable()
export class Settings extends BaseConfig {
  CURRENT_VERSION = (packageInfo as { version: string }).version;
  BASE_URL = ''; // Replace with your actual API base URL
}
